"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createBubbleStyle;

function createBubbleStyle(_ref) {
  var bubbleBackground = _ref.bubbleBackground,
      bubbleBorder = _ref.bubbleBorder,
      bubbleBorderRadius = _ref.bubbleBorderRadius,
      bubbleFromUserBackground = _ref.bubbleFromUserBackground,
      bubbleFromUserBorder = _ref.bubbleFromUserBorder,
      bubbleFromUserBorderRadius = _ref.bubbleFromUserBorderRadius,
      bubbleFromUserTextColor = _ref.bubbleFromUserTextColor,
      bubbleMaxWidth = _ref.bubbleMaxWidth,
      bubbleMinHeight = _ref.bubbleMinHeight,
      bubbleTextColor = _ref.bubbleTextColor,
      messageActivityWordBreak = _ref.messageActivityWordBreak;
  return {
    maxWidth: bubbleMaxWidth,
    minHeight: bubbleMinHeight,
    wordBreak: messageActivityWordBreak,
    '&:not(.from-user)': {
      background: bubbleBackground,
      border: bubbleBorder,
      borderRadius: bubbleBorderRadius,
      color: bubbleTextColor
    },
    '&.from-user': {
      background: bubbleFromUserBackground,
      border: bubbleFromUserBorder,
      borderRadius: bubbleFromUserBorderRadius,
      color: bubbleFromUserTextColor
    }
  };
}